import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const signInStyle = StyleSheet.create({
    outerContainer: {
        flex: 1,
        backgroundColor: appColors?.primary
    },
    innerContainer: {
        backgroundColor: appColors?.primary,
        justifyContent: "center",
        alignItems: "center"
    },
    inputContainer: {
        borderWidth: 0.6,
        borderBottomWidth: 0.6,
        borderColor: appColors?.light,
        borderRadius: 10,
        height: 60,
        padding: 10
    },
    inputStyle: {
        paddingLeft: 10,
        fontFamily: appFonts?.medium,
        fontSize: fontSize?.mediumFontSize,
        color: appColors?.light
    },
    labelStyle: {
        fontFamily: appFonts?.medium,
        fontSize: fontSize?.mediumFontSize,
        color: appColors?.light,
        position: "absolute",
        left: 30,
        top: -15,
        backgroundColor: appColors?.primary,
        zIndex: 1,
        paddingHorizontal: 10
    },
    buttonTitleStyle: {
        fontFamily: appFonts?.bold,
        fontSize: fontSize?.mediumFontSize,
        color: appColors?.primary
    },
    buttonStyle: {
        borderRadius: 10,
        backgroundColor: appColors?.light,
        // paddingHorizontal: 40,
        // paddingVertical: 5,
        marginHorizontal: 15
    },
    forgotPinView: {
        alignSelf: "flex-end",
        margin: 10,
        top: 5
    },
    signUpButton: {
        top: 20,
        alignItems: "center",
        flexDirection: "row",
        alignSelf: "center"
    },
    policyView: {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
        position: "absolute",
        bottom: 20,
    }
}) 